// material-ui
import { Box, Typography } from '@mui/material';


// ==============================|| HEADER CONTENT - SEARCH ||============================== //

const Search = () => (
    <Box sx={{ width: '100%', ml: { xs: 0, md: 1 } }}>
        <Typography variant="subtitle2" style={{ fontStyle: 'italic' }}>
            A New Car Dealing Experience
        </Typography>
    </Box>
);

export default Search;
